/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type { ShowStarterDto, ShowScoreEntryDto } from '../models/index';
import { ShowStarterDtoFromJSON, ShowScoreEntryDtoFromJSON } from '../models/index';

export interface ApiShowBookableIdGetRequest {
    id: number;
}

export interface ApiShowStarterGetRequest {
    showId: number;
}

export interface ApiShowScoresGetRequest {
    showId: number;
    scoringType: number;
}

export interface ApiShowYearHistoryGetRequest {
    year: number;
    scoringType: number;
}

/**
 * 
 */
export class ShowApi extends runtime.BaseAPI {

    /**
     */
    async apiShowBookableGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Show/bookable`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiShowBookableGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiShowBookableGetRaw(initOverrides);
    }

    /**
     */
    async apiShowBookableIdGetRaw(requestParameters: ApiShowBookableIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiShowBookableIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Show/bookable/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiShowBookableIdGet(requestParameters: ApiShowBookableIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiShowBookableIdGetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiShowGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Show`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue);
    }

    /**
     */
    async apiShowGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiShowGetRaw(initOverrides);
    }

    /** Alle Starter eines Turniers mit ihren Prüfungen */
    async apiShowStarterGetRaw(requestParameters: ApiShowStarterGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShowStarterDto>>> {
        if (requestParameters['showId'] == null) {
            throw new runtime.RequiredError('showId', 'Required parameter "showId" was null or undefined.');
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY");
        }
        const response = await this.request({
            path: `/api/Show/starter`,
            method: 'GET',
            headers: headerParameters,
            query: { showId: requestParameters['showId'] },
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShowStarterDtoFromJSON));
    }

    async apiShowStarterGet(requestParameters: ApiShowStarterGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShowStarterDto>> {
        const response = await this.apiShowStarterGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /** Gesamtwertung eines Turniers nach Wertungstyp */
    async apiShowScoresGetRaw(requestParameters: ApiShowScoresGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShowScoreEntryDto>>> {
        if (requestParameters['showId'] == null) {
            throw new runtime.RequiredError('showId', 'Required parameter "showId" was null or undefined.');
        }
        if (requestParameters['scoringType'] == null) {
            throw new runtime.RequiredError('scoringType', 'Required parameter "scoringType" was null or undefined.');
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY");
        }
        const response = await this.request({
            path: `/api/Show/scores`,
            method: 'GET',
            headers: headerParameters,
            query: { showId: requestParameters['showId'], scoringType: requestParameters['scoringType'] },
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShowScoreEntryDtoFromJSON));
    }

    async apiShowScoresGet(requestParameters: ApiShowScoresGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShowScoreEntryDto>> {
        const response = await this.apiShowScoresGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /** Jahreswertung */
    async apiShowYearHistoryGetRaw(requestParameters: ApiShowYearHistoryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShowScoreEntryDto>>> {
        if (requestParameters['year'] == null) {
            throw new runtime.RequiredError('year', 'Required parameter "year" was null or undefined.');
        }
        if (requestParameters['scoringType'] == null) {
            throw new runtime.RequiredError('scoringType', 'Required parameter "scoringType" was null or undefined.');
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY");
        }
        const response = await this.request({
            path: `/api/Show/yearhistory`,
            method: 'GET',
            headers: headerParameters,
            query: { year: requestParameters['year'], scoringType: requestParameters['scoringType'] },
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShowScoreEntryDtoFromJSON));
    }

    async apiShowYearHistoryGet(requestParameters: ApiShowYearHistoryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShowScoreEntryDto>> {
        const response = await this.apiShowYearHistoryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
